import axios from "axios";
import { GET_ADDRESS_MAPS_URL, SEARCH_ADDRESS_MAPS_URL } from "./Constant";

/**
 * Mendapatkan detail alamat berdasarkan latitude dan longitude menggunakan OpenStreetMap / Nominatim (Leaflet).
 * Output diformat agar kompatibel dengan komponen yang sebelumnya menggunakan format Google Maps.
 * 
 * @param {number|string} lat - Latitude
 * @param {number|string} lng - Longitude
 * @returns {Promise<Object>} Data alamat
 */
export const getAddressMap = async (lat, lng) => {
  if (!lat || !lng) {
    return {
      results: [],
      display_name: "",
      formatted_address: "",
      status: "ZERO_RESULTS",
    };
  }

  try {
    const res = await axios.get(
      `${GET_ADDRESS_MAPS_URL}?format=json&lat=${lat}&lon=${lng}&addressdetails=1`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    const data = res.data || {};
    const formattedAddress = data.display_name || "";

    // Struktur balik kompatibel ganda (mendukung data.results[2].formatted_address, data.display_name, dan data.formatted_address)
    return {
      ...data,
      display_name: formattedAddress,
      formatted_address: formattedAddress,
      results: [
        { formatted_address: formattedAddress },
        { formatted_address: formattedAddress },
        { formatted_address: formattedAddress },
      ],
      status: "OK",
    };
  } catch (error) {
    console.error("Error fetching address from Leaflet / Nominatim:", error);
    return {
      results: [],
      display_name: "",
      formatted_address: "",
      status: "ERROR",
    };
  }
};

/**
 * Mencari alamat atau lokasi berdasarkan query teks menggunakan OpenStreetMap / Nominatim (Leaflet).
 * 
 * @param {string} query - Kata kunci pencarian alamat
 * @returns {Promise<Array>} Daftar lokasi hasil pencarian
 */
export const searchAddressMap = async (query) => {
  if (!query || typeof query !== "string" || !query.trim()) return [];

  try {
    const res = await axios.get(
      `${SEARCH_ADDRESS_MAPS_URL}?format=json&q=${encodeURIComponent(query.trim())}&addressdetails=1&limit=5`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    return res.data || [];
  } catch (error) {
    console.error("Error searching address from Leaflet / Nominatim:", error);
    return [];
  }
};